chatClient.directive('bindFocus', [
    '$timeout',
    function ($timeout) {
        return {
            restrict: 'A',
            scope: {
                bindFocus: '=bindFocus'
            },
            link: function (scope, element, attrs) {
                //'Watches' the value passed into the bind-focus attribute for any changes
                //This is to programmatically focus inputs
                scope.$watch(
                    function () {
                        return scope.bindFocus;
                    },
                    function (focusInput) {
                        var isInputFocused = $('#chat textarea').is(':focus');

                        //Timeouts necessary for digest
                        if (focusInput && !isInputFocused) {
                            $timeout(function () {
                                element[0].focus();
                            });
                        } else if (!focusInput && isInputFocused) {
                            $timeout(function () {
                                element[0].blur();
                            });
                        }
                    }
                );

                element.on('focus', function () {
                    scope.bindFocus = true;
                    $timeout(function () {}); //Timeout necessary for digest
                });

                element.on('blur', function () {
                    scope.bindFocus = false;
                    $timeout(function () {}); //Timeout necessary for digest
                });
            }
        };
    }
]);
